<template lang="pug">
  block content
    include ../pug/mixin/content.pug
    .is
        .container
          .connect
            .connect__content
              .is__title.connect__title(v-html="tr.connect.title")
              .is__dsc.connect__dsc.connect__dsc_m_66
                span(v-html="tr.connect.dsc")

              vButton.is__btn( large :href="linkOffice + '/site/login?lang='+lang", target="_blank") {{tr.connect.btn}}
            img.connect__img(src=`../assets/images/it_1(1).png`, alt="")

        .is__gradient
        .is__color
            .container
                .team
                    img.team__phone(src=`../assets/images/main-content/img_3.png`, alt="" v-if="!englishVersion && !mexicoVersion")
                    img.team__phone(src=`../assets/images/main-content/img_3_en.png`, alt="" v-if="englishVersion || mexicoVersion")
                    .team__b
                        .partner-network-inner
                            .how__partners
                                PartnerNetwork
                        .team__dsc
                            span(v-html="tr.team")
                .benefit
                    .benefit__shops.team__shops
                        .is__subtitle.benefit__title(v-html="tr.benefit.shops.title")

                        ol.benefit__ol
                            li.benefit__item(v-for="i in tr.benefit.shops.ol" v-if="i!==''" v-html="i")
                        EditableBlock(
                          :text="tr.benefit.you.btn"
                          :field="'benefit.you.btn'"
                          section="it"
                          style="margin-top: 42px;"
                        )
                          //vButton.is__btn.benefit__btn( large :href="linkSwitips + '/?locale='+lang_switips_link+'#register'", target="_blank" v-if="lang_switips !== 'en'") {{tr.benefit.you.btn}}
                          //vButton.is__btn.benefit__btn( large :href="linkPlanet + '/?locale='+lang_switips_link+'#register'", target="_blank" v-if="lang_switips === 'en'") {{tr.benefit.you.btn}}
                          vButton.is__btn.benefit__btn(:href="urlToPartner()" target="_blank" large) {{tr.benefit.you.btn}}

                    .benefit__you.team__you
                        .is__subtitle.benefit__title.team__title
                            span(v-html="tr.benefit.you.title")
                        ol.benefit__ol
                            li.benefit__item(v-for="i in tr.benefit.you.ol" v-if="i!==''" v-html="i")
</template>

<script>
import vButton from '../components/elements/vButton'
import PartnerNetwork from '../components/widgets/PartnerNetwork'
import EditableBlock from '../components/widgets/EditableBlock'
import langOps from '@/mixins/langOps'

export default {
  components: {
    vButton,
    PartnerNetwork,
    EditableBlock
  },
  data () {
    return {
      section: 'it'
    }
  },
  mixin: [langOps],
  computed: {
    linkOffice () {
      return process.env.VUE_APP_OFFICE
    },
    linkSwitips () {
      return process.env.VUE_APP_SWITIPS
    },
    linkPlanet () {
      return process.env.VUE_APP_MYSWITPLANET
    }
  },
  methods: {
    urlToPartner () {
      if (this.$route.query.us === 'true' && this.$route.query.u !== undefined) {
        return `${process.env.VUE_APP_MARKET}/?locale=${this.lang_switips_link}&u=${this.$route.query.u}&us=${this.$route.query.us}`
      }
      if (this.$route.query.us === 'true' && this.$route.query.u === undefined) {
        return `${process.env.VUE_APP_MARKET}/?locale=${this.lang_switips_link}&us=${this.$route.query.us}`
      }
      if (this.$route.query.u) {
        return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}&u=${this.$route.query.u}&us=${this.$route.query.us}`
      }
      if (this.lang_switips === 'ru') {
        return `${process.env.VUE_APP_SWITIPS_DYNAMIC}/?locale=${this.lang_switips_link}#register`
      }
      if (this.lang_switips === 'uk' || this.lang_switips === 'kz') {
        return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}#register`
      }
      if (this.lang_switips === 'en' || this.lang_switips === 'es') {
        return `${process.env.VUE_APP_MYSWITPLANET}/?locale=${this.lang_switips_link}#register`
      }
      return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}#register`
    }
  }
}
</script>

<style lang="scss">
  @import './Page.scss';
</style>
